// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3flKF","index":"styles_index__1TLZE"};